// extracted by mini-css-extract-plugin
export var container = "H2WithSubtitle-module--container--BJmSK";
export var subtitle = "H2WithSubtitle-module--subtitle--JlI6S";